import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { FooterModule } from '../footer/footer.module';
import { HeaderModule } from '../header/header.module';
import { BaseComponent } from './base.component';
import { BaseResolver } from './base.resolver';

@NgModule({
  imports: [CommonModule, HeaderModule, FooterModule, SharedModule],
  declarations: [BaseComponent],
  providers: [BaseResolver],
})
export class BaseModule {}
